// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2mYkG","footer":"Form_footer__GfUlJ"};